import Layout from "./Layout.js";
import { LayoutHeader } from "./Header.js";
import { LayoutFooter } from "./Footer.js";
import { LayoutSider } from "./Sider.js";
import { LayoutContent } from "./Content.js";
import "./style/index.css";
Layout.Header = LayoutHeader;
Layout.Footer = LayoutFooter;
Layout.Sider = LayoutSider;
Layout.Content = LayoutContent;
export * from "./Layout.js";
export * from "./Header.js";
export * from "./Footer.js";
export * from "./Sider.js";
export * from "./Content.js";
export default Layout;